










































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
/**
 * Handle options such as deletion/rejection
 */
export default class CptOptions extends Vue {
  /**
   * state while deleting request is pending
   */
  @Prop({ type: Boolean }) isBeingDeleted!: boolean;

  /**
   * Btn size
   */
  @Prop({ type: String }) btnSize!: string;

  /**
   * Btn size getter
   */
  get definedBtnSize(): string {
    return this.btnSize ? this.btnSize : "sm";
  }

  /**
   * inform parent about deletion
   */
  deleteCPT(): void {
    this.$emit("delete");
  }
}
